import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useGiftBanner() {
    const { data } = useQuery(queries.banners.list('GIFT'));
    return data?.banners;
}

export default useGiftBanner;
